/**
 * LanguageSection — App language (UI language) preference
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionCard, OptionSelector } from '../ui';
import { useUserPreferencesStore } from '../../store/userPreferencesStore';
import { selectSourceLocale, selectTargetLocale } from '../../store/userPreferencesSelectors';
import { useUILanguage } from '../../i18n/useUILanguage';
import { getLanguageDisplayName } from '../../i18n';
import { getBaseLanguage } from '../../types/locale';

export const LanguageSection = React.memo(function LanguageSection() {
  const { t, i18n } = useTranslation();

  const sourceLocale = useUserPreferencesStore(selectSourceLocale);
  const targetLocale = useUserPreferencesStore(selectTargetLocale);
  const { currentPreference: uiLangPref, changeLanguage: changeUILanguage } = useUILanguage();

  return (
    <SectionCard title={t('profile.language.title')}>
      <OptionSelector
        label={t('profile.language.appLanguage')}
        options={(['source', 'target'] as const).map((pref) => ({
          value: pref,
          label: getLanguageDisplayName(
            getBaseLanguage(pref === 'source' ? sourceLocale : targetLocale),
            i18n.language,
          ),
        }))}
        value={uiLangPref}
        onChange={changeUILanguage}
        testID="profile-ui-lang"
      />
    </SectionCard>
  );
});
